import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateDeliveryReturnStatusMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  status: Types.Scalars['String']['input'];
  now: Types.Scalars['timestamptz']['input'];
}>;


export type UpdateDeliveryReturnStatusMutation = { __typename?: 'mutation_root', update_delivery_returns_by_pk?: { __typename?: 'delivery_returns', id: number, status: string, received_at?: string | null } | null };


export const UpdateDeliveryReturnStatusDocument = gql`
    mutation UpdateDeliveryReturnStatus($id: bigint!, $status: String!, $now: timestamptz!) {
  update_delivery_returns_by_pk(
    pk_columns: {id: $id}
    _set: {status: $status, received_at: $now, updated_at: $now}
  ) {
    id
    status
    received_at
  }
}
    `;
export type UpdateDeliveryReturnStatusMutationFn = Apollo.MutationFunction<UpdateDeliveryReturnStatusMutation, UpdateDeliveryReturnStatusMutationVariables>;

/**
 * __useUpdateDeliveryReturnStatusMutation__
 *
 * To run a mutation, you first call `useUpdateDeliveryReturnStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDeliveryReturnStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDeliveryReturnStatusMutation, { data, loading, error }] = useUpdateDeliveryReturnStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useUpdateDeliveryReturnStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDeliveryReturnStatusMutation, UpdateDeliveryReturnStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDeliveryReturnStatusMutation, UpdateDeliveryReturnStatusMutationVariables>(UpdateDeliveryReturnStatusDocument, options);
      }
export type UpdateDeliveryReturnStatusMutationHookResult = ReturnType<typeof useUpdateDeliveryReturnStatusMutation>;
export type UpdateDeliveryReturnStatusMutationResult = Apollo.MutationResult<UpdateDeliveryReturnStatusMutation>;
export type UpdateDeliveryReturnStatusMutationOptions = Apollo.BaseMutationOptions<UpdateDeliveryReturnStatusMutation, UpdateDeliveryReturnStatusMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/updateDeliveryReturnStatus.mutation.gql}
 */
export async function updateDeliveryReturnStatus(
  variables: UpdateDeliveryReturnStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateDeliveryReturnStatusMutation['update_delivery_returns_by_pk']>
export async function updateDeliveryReturnStatus(
  variables: UpdateDeliveryReturnStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateDeliveryReturnStatusMutation>
export async function updateDeliveryReturnStatus(
  variables: UpdateDeliveryReturnStatusMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateDeliveryReturnStatusMutation['update_delivery_returns_by_pk'] | UpdateDeliveryReturnStatusMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateDeliveryReturnStatusMutation>(
    UpdateDeliveryReturnStatusDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_delivery_returns_by_pk
}